(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[472],{

/***/ 1405:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/contents/thai-word-count-tools",
      function () {
        return __webpack_require__(8947);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 3605:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);

const AdSenseBanner = (param)=>{
    let { adUnitId , adSlotId  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "p-1",
        align: "center",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ins", {
            className: "adsbygoogle",
            style: {
                display: "block"
            },
            "data-ad-client": "".concat(adUnitId),
            "data-ad-slot": "".concat(adSlotId),
            "data-ad-format": "auto",
            "data-full-width-responsive": "true"
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (AdSenseBanner);


/***/ }),

/***/ 6032:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);

const AdsenseInContent = (param)=>{
    let { adUnitId , adSlotId  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "p-1",
        align: "center",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ins", {
            className: "adsbygoogle",
            style: {
                display: "block",
                textAlign: "center"
            },
            "data-ad-layout": "in-article",
            "data-ad-format": "fluid",
            "data-ad-client": "".concat(adUnitId),
            "data-ad-slot": "".concat(adSlotId)
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (AdsenseInContent);


/***/ }),

/***/ 8947:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ SeoSuitableContentLengthPage; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _components_AdsenseInContent__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6032);
/* harmony import */ var _components_AdSenseBanner__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3605);





function SeoSuitableContentLengthPage() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "container",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("title", {
                        children: [
                            "อยากนับคำภาษาไทยทำยังไงได้บ้าง รวมเครื่องมือนับคำสำหรับภาษาไทย ตัวช่วยที่ทำให้งานของนักเขียนง่ายขึ้น | ",
                            "CanCount"
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "description",
                        content: "รวมเครื่องมือนับคำสำหรับภาษาไทย ตัวช่วยที่ทำให้งานของนักเขียนง่ายขึ้น"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "keywords",
                        content: "เครื่องมือ นับคำ, เครื่องมือ นับคำ ภาษาไทย"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "og:title",
                        content: "รวมเครื่องมือนับคำสำหรับภาษาไทย ตัวช่วยที่ทำให้งานของนักเขียนง่ายขึ้น | ".concat("CanCount")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "og:description",
                        content: "รวมเครื่องมือนับคำ นับคำภาษาไทย ตัวช่วยที่ทำให้งานของนักเขียนง่ายขึ้น"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("main", {
                className: "w-100",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "mt-2 mb-1 card",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "mx-4 py-2 my-2",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                                className: "h3",
                                children: "อยากนับคำภาษาไทยทำยังไงได้บ้าง รวมเครื่องมือนับคำสำหรับภาษาไทย ตัวช่วยที่ทำให้งานของนักเขียนง่ายขึ้น"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                children: "จำนวนคำ และความยาวของบทความ เป็นหนึ่งในรายละเอียดที่นักเขียนทุกคนมักให้ความสำคัญอยู่เสมอ เพราะจำนวนคำ และความยาวของบทความส่งผลต่อคุณภาพของงานเขียน ทั้งงานเขียนนิยายหรือบทความทั่วๆ ไป ที่ความยาวก็ส่งผลต่อความรู้สึกของผู้อ่าน หรือจะเป็นบทความ SEO ที่ความยาวและคุณภาพของบทความจะส่งผลต่อตำแหน่งในหน้าผลการค้นหา การนับจำนวนคำที่แม่นยำจึงเป็นสิ่งที่ไม่ควรมองข้าม บทความนี้จึงรวบรวมเอา เครื่องมือนับคำที่น่าสนใจ มาฝากเหล่านักเขียนทุกท่าน"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                className: "h4",
                                children: "สารบัญ"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                                className: "topic-list-content",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                            href: "#ms-word",
                                            children: "โปรแกรม Microsoft Word"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                            href: "#android-word-counter",
                                            children: "แอปพลิเคชัน Word Counter"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                            href: "#website-cancount",
                                            children: "เว็บไซต์ Cancount"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                            href: "#summary",
                                            children: "สรุป"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {}),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_AdsenseInContent__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                adSlotId: "".concat("6152322995"),
                                adUnitId: "".concat("ca-pub-5783368027852899")
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {}),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                name: "ms-word"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                href: "https://www.microsoft.com/th-th/microsoft-365/word",
                                target: "_blank",
                                rel: "noopener noreferrer",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                    className: "h4",
                                    children: "1. Microsoft Word"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                children: "จัดเป็นโปรแกรมขั้นพื้นฐานสำหรับนักเขียน และผู้ที่ทำงานเกี่ยวกับเอกสาร โปรแกรม Microsoft Word สามารถตั้งค่าเพื่อแสดงผลนับจำนวนคำได้ สามารถนับจำนวนคำทั้งภาษาไทย และภาษาอังกฤษได้อย่างแม่นยำ"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                children: "จุดเด่นของการนับคำด้วยแอปพลิเคชั่น Microsoft Word"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                                className: "list-content",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                        children: "เป็นโปรแกรมที่ผู้ใช้งานฝั่ง Window และทำงานเอกสารมักจะมีติดอยู่แล้ว"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                        children: "นับจำนวนคำท้ังภาษาไทย และภาษาอังกฤษได้อย่างแม่นยำ"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                        children: "เป็นโปรแกรมที่ผู้คนส่วนใหญ่ใช้เพื่อนับจำนวนคำ จึงใช้ในการอ้างอิงจำนวนคำได้"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {}),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                children: "ข้อสังเกตเล็กน้อยของโปรแกรม Microsoft Word คือต้องเป็นเวอร์ชันที่ติดตั้งบนคอมพิวเตอร์จึงจะสามารถนับคำภาษาไทยได้"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                name: "android-word-counter"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                href: "https://play.google.com/store/apps/details?id=wordtextcounter.details.main",
                                target: "_blank",
                                rel: "noopener noreferrer",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                    className: "h4",
                                    children: "2. แอปพลิเคชัน Word Counter"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                children: "แอปพลิเคชันนับจำนวนคำในระบบ Android ที่สามารถดาวน์โหลดมาใช้งานได้ฟรี ใช้งานง่าย สามารถนับคำได้หลากหลายภาษา ทั้งภาษาไทย ภาษาอังกฤษ อาหรับ เยอรมัน สเปน ฝรั่งเศส ฯลฯ ได้อย่างแม่นยำ มาพร้อมกับข้อมูลสถิติที่มีประโยชน์ ทั้งเวลาที่ใช้ในการอ่าน/พูด/เขียน พร้อมระบบบันทึกงานโดยอัตโนมัติ"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                children: "จุดเด่นของการนับคำด้วยแอปพลิเคชั่น Word Counter"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                                className: "list-content",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                        children: "ใช้นับคำได้หลากหลายภาษา ทั้งภาษาไทย อังกฤษ ฝรั่งเศส อินโดนีเซีย เยอรมัน โปรตุเกส โรมาเนีย เวียดนาม ฯลฯ"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                        children: "สามารถใช้งานบนโทรศัพท์มือถือได้อย่างง่าย"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                        children: "ฟีเจอร์การใช้งานหลากหลาย ทั้งสถิติเวลา ระบบบันทึกข้อความอัตโนมัติ ระบบบันทึกข้อความสำคัญและสามารถแก้ไขข้อความที่บันทึกไว้ในระบบได้"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                        children: "สามารถแบ่งงานเก็บเป็นโฟลเดอร์ได้ตามความต้องการของผู้ใช้"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {}),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                children: "ข้อสังเกตเล็กน้อยของแอปพลิเคชั่น Word Counter คือใช้งานได้เฉพาะบนโทรศัพท์มือถือ Android"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {}),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                name: "website-cancount"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                                href: "/",
                                passHref: true,
                                legacyBehavior: true,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                        className: "h4",
                                        children: "3. เว็บไซต์ CanCount"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                children: "เป็นเครื่องมือนับคำออนไลน์ที่ถูกพัฒนาขึ้นมาเพื่อใช้นับจำนวนคำได้ทั้งภาษาอังกฤษ และนับคำภาษาไทย ที่นับจำนวนคำได้อย่างแม่นยำ พร้อมบอกจำนวนความหนาแน่นของคำ คำที่ตรวจพบในบทความ ประมาณการเวลาที่ใช้ในการอ่านและเวลาที่ใช้ในการพูดให้อย่างครบครัน สามารถใช้นับคำออนไลน์ได้จากทุกอุปกรณ์"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                                className: "list-content",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                        children: "นับจำนวนคำได้อย่างแม่นยำ โดยเฉพาะการนับคำภาษาไทย"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                        children: "ใช้งานได้ฟรี ไม่จำกัดจำนวนครั้ง"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                        children: "สามารถดึงข้อมูลจากไฟล์งานได้โดยตรง (.pdf/.docx/.txt)"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                        children: "เนื่องจากเป็นเว็บไซต์จึงสามารถใช้ได้ทั้งบนคอมพิวเตอร์ และโทรศัพท์มือถือ"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                        children: "บอกความหนาแน่นของคำ และคำที่ตรวจพบในข้อความ ใช้ตรวจเช็กคำซ้ำ หรือจำนวนคำเชื่อมประโยคได้"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                        children: "ไม่ต้องติดตั้งโปรแกรมให้วุ่นวาย"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {}),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                children: "ข้อสังเกตเล็กน้อยของเว็บไซต์ CanCount คือมีการติดโฆษณานะ (ค่าโฆษณาไว้จ่ายค่าโฮสติ้งและค่าโดเมนแหละ)"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {}),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_AdSenseBanner__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                adSlotId: "".concat("6152322995"),
                                adUnitId: "".concat("ca-pub-5783368027852899")
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                name: "summary"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                className: "h4",
                                children: "4. สรุป"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                                className: "list-content",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                        children: [
                                            "หากคุณใช้งานคอมพิวเตอร์และมี",
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                href: "https://www.microsoft.com/th-th/microsoft-365/word",
                                                target: "_blank",
                                                rel: "noopener noreferrer",
                                                children: "โปรแกรม Microsoft Word"
                                            }),
                                            " ",
                                            "อยู่แล้วคุณก็สามารถนับจำนวนคำได้อยู่แล้ว"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                        children: [
                                            "หากว่าคุณกำลังใช้โทรศัพท์มือถือ Android ก็มี",
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                href: "https://play.google.com/store/apps/details?id=wordtextcounter.details.main",
                                                target: "_blank",
                                                rel: "noopener noreferrer",
                                                children: "แอปพลิเคชัน Word Counter"
                                            }),
                                            " ",
                                            "เป็นอีกทางเลือกสำหรับคุณ"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                        children: [
                                            "แต่หากว่าคุณไม่ได้มีโปรแกรมที่กล่าวถึงทั้งคู่ และไม่อยากติดตั้งโปรแกรมเพิ่มเติม",
                                            " ",
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                                                href: "/",
                                                passHref: true,
                                                legacyBehavior: true,
                                                children: "เว็บไซต์ CanCount"
                                            }),
                                            "เป็นตัวเลือกที่ช่วยให้การนับคำของคุณสะดวกขึ้นอย่างแน่นอน"
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                children: "และนี่ก็เป็นเครื่องมือนับจำนวนคำ ที่ช่วยให้นักเขียนทำงานได้สะดวกสบายขึ้นอย่างแน่นอน โดยมีทั้งเครื่องมือนับคำรูปแบบออนไลน์ และออฟไลน์ให้ได้เลือกใช้กันตามสะดวก โดยเฉพาะเครื่องมือนับคำทางออนไลน์ ที่สามารถเข้าใช้ได้ทั้งโทรศัพท์มือถือและคอมพิวเตอร์ที่สะดวกยิ่งกว่า เครื่องมือนับจำนวนคำ CanCount ที่จะช่วยนับจำนวนคำทั้งภาษาไทย และภาษาอังกฤษได้อย่างแม่นยำ ใช้งานง่าย และที่สำคัญยังใช้ฟรีได้ไม่จำกัดจำนวนครั้งอีกด้วย"
                            })
                        ]
                    })
                })
            })
        ]
    });
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [774,888,179], function() { return __webpack_exec__(1405); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);